import { render } from "./Favorites.vue?vue&type=template&id=01c1e2f4&scoped=true&ts=true"
import script from "./Favorites.vue?vue&type=script&lang=ts"
export * from "./Favorites.vue?vue&type=script&lang=ts"

import "./Favorites.vue?vue&type=style&index=0&id=01c1e2f4&lang=scss&scoped=true"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c1e2f4"]])

export default __exports__